export default ({ authGuard, guestGuard }) => [
	...guestGuard([
		{
			path: '/login',
			name: 'Login',
			component: () => import('/src/pages/Login.vue'),
		},
	]),
	...authGuard([
		{
			path: '/',
			name: 'Home',
			component: () => import('/src/pages/Home.vue'),
		},
	]),
];
